import noctuagg from '../../noctuagg.json'
import Adjust from '@adjustcom/adjust-web-sdk'

const adjustEventMap = noctuagg.adjust.android.eventMap

export interface AdjustTrackerConfig {
  appToken: string
  environment: 'sandbox' | 'production'
}

export const initializeAdjustTracker = async ({ appToken, environment }: AdjustTrackerConfig) => {
  console.log('====================== Adjust Initialization =======================')
  console.log('Initializing Adjust tracker...')

  try {
    if (!appToken || !environment) {
      console.warn('Adjust configuration incomplete, skipping initialization')
      return
    }

    Adjust.initSdk({
      appToken,
      environment,
    })

    console.log('Adjust tracker initialized successfully')
  } catch (error) {
    console.error('Failed to initialize Adjust tracker:', error)
  }
}

const sanitizeEventProperties = (eventProperties: Record<string, unknown>) => {
  return Object.entries(eventProperties).reduce<Record<string, string>>((acc, [key, value]) => {
    try {
      if (value === undefined) return acc
      acc[key] = typeof value === 'string' ? value : JSON.stringify(value)
    } catch {
      acc[key] = String(value)
    }
    return acc
  }, {})
}

export const trackAdjustEvent = async (
  eventName: string,
  eventProperties: Record<string, unknown> = {},
) => {
  Adjust.trackEvent({
    eventToken: adjustEventMap[eventName as keyof typeof adjustEventMap] || eventName,
    callbackParams: Object.entries(sanitizeEventProperties(eventProperties)).map(
      ([key, value]) => ({
        key,
        value,
      }),
    ),
  })
}
